module.exports = __webpack_public_path__ + "img/image-placeholder-300.52139879.png";